import { useState, Fragment } from 'react'
import { Field } from 'redux-form'
import { TransitionDropList, Modal, Button } from '@vzmi/shp_shared_compo'
import { FormValueSelector } from '../../../Common/forms'
import { CheckboxInputField, FormRow } from '../../../Common/Form'
import Editor from '../../../Proposal/Common/ProposalForm/Editor/Editor'
import Warranty from '../../../Proposal/ProductListingBaseForm/Media/Warranty'
import StatusPrefixBlock from '../../Common/PrefixBlock/Status'
import DuplicatedPrefixBlock from '../../Common/PrefixBlock/Duplicated'
import ListingCollapseBlock from '../../Common/ListingCollapseBlock'
import CardSectionTitle from '../../Common/CardSectionTitle'
import styles from './index.css'
import {
  GA_CLICK_ACTION,
  getI13nModel
} from '../../BatchApply.ga'
import { sendI13nClickEvent } from '../../../../../lib/i13nUtil'
import useVisibleViewport from '../../../../hooks/useVisibleViewport'

const {
  TransitionDropListContainer,
  TransitionDropItem
} = TransitionDropList

const CopyAndWarrantyRow = props => {
  const {
    index,
    listing = {},
    batchResult,
    isOverviewPage,
    duplicatedMap,
    proposalType,
    onRemove,
    readOnly,
    change,
    flags,
    user,
    onLayoutChange,
    onUpdate,
    withoutMargin,
    i13n,
    isEditPage
  } = props
  const {
    skuDetail: {
      shipType
    } = {},
    isUpdateWithWarranty,
    copy = ''
  } = listing
  const { visible: viewportVisible, viewportRef } = useVisibleViewport({
    onEnterViewport: () => onLayoutChange()()
  })
  const [visible, setVisible] = useState(false)
  const fieldPrefix = `listings[${index}]`

  const sendPageview = (action) => {
    const i13nModel = getI13nModel(action)
    sendI13nClickEvent({ i13n, i13nModel })
  }
  const showModal = () => {
    setVisible(true)
  }
  const onOk = () => {
    onUpdate(listing)
    // click GA
    sendPageview({
      type: GA_CLICK_ACTION.BATCH_APPLY_WARRANTY
    })
    setVisible(false)
  }
  const onCancel = () => {
    setVisible(false)
  }
  return (
    <>
      {/* 更新成功失敗區塊 */}
      <StatusPrefixBlock
        proposalType={proposalType}
        listing={listing}
        batchResult={batchResult}
        isOverviewPage={isOverviewPage}
      />
      {/* 賣場含有共用商品區塊 */}
      <DuplicatedPrefixBlock
        proposalType={proposalType}
        duplicatedMap={duplicatedMap}
        listing={listing}
      />
      {/* 賣場區塊 */}
      <ListingCollapseBlock
        batchResult={batchResult}
        proposalType={proposalType}
        onRemove={onRemove}
        onCollapseChange={onLayoutChange()}
        listing={listing}
        readOnly={readOnly}
      >
        <CardSectionTitle>
          賣場詳情
        </CardSectionTitle>
        <div
          ref={viewportRef}
          className={styles.copyArea}
        >
          <Editor
            fieldName={`${fieldPrefix}.copy`}
            className={styles.copy}
            shipType={shipType}
            // 限制整個頁面只會有一個 tinymce editor 避免網頁負擔過重
            readOnly={readOnly || !viewportVisible}
            copy={copy}
            isEditPage={isEditPage}
            withYouTubeCover
          />
        </div>
        <CardSectionTitle>
          <Field
            component={CheckboxInputField}
            name={`${fieldPrefix}.isUpdateWithWarranty`}
            className={styles.isUpdateWithWarranty}
            label='同時修改商品保證'
            readOnly={readOnly}
          />
        </CardSectionTitle>
        {
          isUpdateWithWarranty && (
            <div className={styles.warrantyArea}>
              {
                !readOnly // [提案修改頁]才進這段
                  ? (
                    <FormRow
                      key='updateWarrantyBtn'
                      label=''
                      withoutMargin={withoutMargin}
                    >
                      <Fragment key={listing.id}>
                        <Button
                          data-role='update-warranty-botton'
                          className={styles.updateWarrantyBtn}
                          onClick={showModal}
                          buttonType='outline'
                          size='medium'
                        >
                          批次套用
                        </Button>
                        <Modal
                          visible={visible}
                          closable
                          destroyOnClose
                          onOk={onOk}
                          onCancel={onCancel}
                        >
                          {`確認將賣場 ${listing.id} 的商品保證套用到此次提案之所有賣場上?`}
                        </Modal>
                      </Fragment>
                    </FormRow>
                  )
                  : null
              }
              <Warranty
                fieldName={`${fieldPrefix}.warranty`}
                triggerFieldChange={change}
                flags={flags}
                user={user}
                isNewProposal={false}
                readOnly={readOnly}
              />
            </div>
          )
        }
      </ListingCollapseBlock>
    </>
  )
}

const CopyAndWarrantyRows = props => {
  const {
    proposalType,
    readOnly,
    onRemove,
    batchResult,
    duplicatedMap = {},
    isOverviewPage,
    change,
    flags,
    user,
    onUpdate,
    i13n,
    isEditPage
  } = props

  return (
    <FormValueSelector
      // redux proposal form listings
      selector={select => ({
        listings: select('listings')
      })}
    >
      {({ listings = [] }) => {
        return (
          // 刪除賣場轉場容器
          <TransitionDropListContainer>
            {listings.map((listing, index) => {
              const listingId = listing.id
              return (
                <TransitionDropItem
                  key={listingId}
                  id={listingId}
                >
                  {onLayoutChange => (
                    <CopyAndWarrantyRow
                      index={index}
                      proposalType={proposalType}
                      listing={listing}
                      batchResult={batchResult}
                      isOverviewPage={isOverviewPage}
                      duplicatedMap={duplicatedMap}
                      onRemove={onRemove}
                      readOnly={readOnly}
                      change={change}
                      flags={flags}
                      user={user}
                      onLayoutChange={onLayoutChange}
                      onUpdate={onUpdate}
                      i13n={i13n}
                      isEditPage={isEditPage}
                    />
                  )}
                </TransitionDropItem>
              )
            })}
          </TransitionDropListContainer>
        )
      }}
    </FormValueSelector>
  )
}

export default CopyAndWarrantyRows
